import InviteModal from 'components/Modal/InviteModal'
import { roomImageAtom, roomTitleAtom } from 'config/store'
import { getAllGameQuery } from 'dataLayer/game'
import { useAtom } from 'jotai'
import { useQuery } from 'react-query'
import { Outlet, useParams } from 'react-router-dom'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import OtherGame from './OtherGame'

function RoomPageLayout() {
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	const [roomTitle] = useAtom(roomTitleAtom)
	const [roomImage] = useAtom(roomImageAtom)
	const { data: games } = useQuery(getAllGameQuery())
	const { roomId } = useParams()
	let dataSelect = games && games.find(item => item.id == roomId)
	return (
		<div className="roompage-layout-container mt-md-3">
			{isMobileMD ? null : <h1>{dataSelect?.name || roomTitle}</h1>}
			{isMobileMD ? (
				<img
					src={dataSelect?.image || roomImage}
					alt="Room game"
					className="room-image"
				/>
			) : null}
			<Outlet />
			{isMobileMD ? null : <OtherGame />}
			<InviteModal />
		</div>
	)
}

export default RoomPageLayout
